<template>
  <div>
    <el-row
      v-loading="isLoading"
      :gutter="10"
    >
      <el-col :md="12">
        <h2>Save Invoice</h2>
        <p>If you would like to replace the file, re-upload it to the upload box.</p>
        <p>Or click submit immediately.</p>
      </el-col>
      <el-col
        :md="12"
        style="text-align: center;"
      >
        <el-upload
          ref="uploader"
          action=""
          :auto-upload="false"
          :on-change="onFileChange"
          accept=".CSV, .XLSX, .XLS"
          drag
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div
            slot="tip"
            class="el-upload__tip"
          >
            Spreadsheet file (CSV / XLSX / XLS)
          </div>
        </el-upload>
        <p>{{ replacementFileName }}</p>
        <el-button
          v-if="!!replacement"
          type="danger"
          @click.native="onRemoveReplacement"
        >
          Remove
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    processed: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      replacement: null,
      replacementCount: 0,
      replacementFileName: '',
      isLoading: false
    }
  },
  created () {
    this.finalise()
  },
  methods: {
    finalise () {
      this.download()
    },
    getPrefilled () {
      let contents = this.replacement ? this.replacement : this.$sheep.utils.arrayToCsv(this.processed)
      let count = this.replacementCount ? this.replacementCount : this.processed.length
      let file = {
        name: this.form.file.name,
        type: 'csv',
        repository: 'legacy_invoice_import',
        relative_path: this.form.carrier.reference,
        contents: contents
      }
      let prefilled = {
        job_name: 'import.json.addressbook',
        account: this.form.account,
        carrier: this.form.carrier,
        count: count,
        reference: '',
        total_value: 0,
        gst_value: 0,
        fuel_value: 0,
        key_in_total_ex: this.form.key_in_total_ex,
        key_in_fuel: this.form.key_in_fuel,
        admin_fee: this.form.admin_fee,
        status: this.form.is_grouped ? -10 : 1,
        file: file
      }
      return prefilled
    },
    download () {
      var csvData = new Blob([this.$sheep.utils.arrayToCsv(this.processed)], { type: 'text/csv;charset=utf-8;' })
      // IE11 & Edge
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, 'invoice-import.csv')
      } else {
        // In FF link must be added to DOM to be clicked
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(csvData)
        link.setAttribute('download', 'invoice-import.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    onFileChange (file, fileList) {
      this.$refs.uploader.clearFiles()
      if (file) {
        this.$set(this, 'replacementFileName', file.name)
        let fileRaw = file.raw
        var rABS = true
        var reader = new FileReader()

        reader.onload = (e) => {
          let contents = !rABS ? new Uint8Array(e.target.result) : e.target.result
          this.$set(this, 'replacement', contents)
          this.$set(this, 'replacementCount', contents.split(/\r\n|\r|\n/).length)
        }

        if (rABS) {
          reader.readAsBinaryString(fileRaw)
        } else {
          reader.readAsArrayBuffer(fileRaw)
        }
      }
    },
    onRemoveReplacement () {
      this.$set(this, 'replacement', null)
      this.$set(this, 'replacementCount', 0)
      this.$set(this, 'replacementFileName', '')
    },
    save () {
      this.isLoading = true

      this.$sdk.invoiceimport.create(this.getPrefilled())
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isLoading = false
          this.$emit('close')
        })
    }
  }
}
</script>

<style>

</style>
